import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

export interface InsertGoogleIAPPayload {
  formData: FormData;
}

interface InsertGoogleIAPResponse {
  message?: string;
  social_account_id?: number | string;
}

export const useInsertGoogleIAP = () => {
  const queryClient = useQueryClient();

  return useMutation<InsertGoogleIAPResponse, Error, InsertGoogleIAPPayload>({
    mutationFn: async ({ formData }) => {
      return httpService.post<InsertGoogleIAPResponse, FormData>(
        API_CONFIG.path.googleIapInsert,
        formData
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["integrations"] });
    },
  });
};
